import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "@/components/AuthLayout";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "client" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await register(form);
      toast.success("Compte créé avec succès");
      navigate(user.role === "artist" ? "/espace-artiste" : "/espace-client");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Créer un compte" subtitle="Rejoignez MYSE et réservez vos stars">
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label className="text-white mb-2 block">Nom complet</Label>
          <Input
            data-testid="register-name"
            value={form.name}
            onChange={(e) => set("name", e.target.value)}
            required
            className="bg-[#181820] border-white/10 text-white"
          />
        </div>
        <div>
          <Label className="text-white mb-2 block">Email</Label>
          <Input
            type="email"
            data-testid="register-email"
            value={form.email}
            onChange={(e) => set("email", e.target.value)}
            required
            className="bg-[#181820] border-white/10 text-white"
          />
        </div>
        <div>
          <Label className="text-white mb-2 block">Mot de passe</Label>
          <Input
            type="password"
            data-testid="register-password"
            value={form.password}
            onChange={(e) => set("password", e.target.value)}
            required
            minLength={6}
            className="bg-[#181820] border-white/10 text-white"
          />
        </div>
        <div>
          <Label className="text-white mb-2 block">Je suis un</Label>
          <div className="grid grid-cols-2 gap-3">
            {[
              { v: "client", l: "Particulier / Client" },
              { v: "artist", l: "Artiste / Manager" },
            ].map((o) => (
              <button
                type="button"
                key={o.v}
                data-testid={`register-role-${o.v}`}
                onClick={() => set("role", o.v)}
                className={`p-3 rounded-xl border text-sm transition ${
                  form.role === o.v
                    ? "border-[#C9A24B] bg-[#C9A24B]/10 text-white"
                    : "border-white/10 text-[#A19E95] hover:border-[#C9A24B]/40"
                }`}
              >
                {o.l}
              </button>
            ))}
          </div>
        </div>
        <Button
          type="submit"
          disabled={loading}
          data-testid="register-submit-btn"
          className="w-full gold-bg text-black font-semibold rounded-full py-6 hover:opacity-90"
        >
          {loading ? "Création..." : "Créer mon compte"}
        </Button>
      </form>
      <p className="text-center text-sm text-[#A19E95] mt-6">
        Déjà inscrit ?{" "}
        <Link to="/connexion" className="text-[#C9A24B] hover:underline">Se connecter</Link>
      </p>
    </AuthLayout>
  );
}
